import "babel-polyfill";
import "slick-carousel";

import { binder, fwa } from "./libs/binder";
import { staticFunctions, constants, commonFunction, anotherCommonFunction, navFunction, myUnusedFunction } from "./modules/module";
import { accordion } from "./modules/accordion";
import { homeSlider } from "./modules/home-slider";
import { animations } from "./modules/animations";




binder({
    bounds: {
        "html": [constants, staticFunctions],
        "body": [commonFunction, anotherCommonFunction],
        ".header": navFunction,
        ".insights-left": accordion,
        ".js-home-slider": homeSlider,
        ".intro-right": animations
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js